import CasBaseRequest from "./base"

export default class CasApis extends CasBaseRequest {
  constructor(config) {
    super(config)
  }

  /**
   *
   *
   * @return {*}
   * @memberof CasApis
   */
  async checkToken(params) {
    return this.post({
      url: "/cas/checkToken",
      data: params
    }).then(res => {
      return Promise.resolve(res)
    })
  }
  async getToken(params) {
    return this.post({
      url: "/cas/getToken",
      data: params
    }).then(res => {
      return Promise.resolve(res)
    })
  }
  async getTicket() {
    return this.get({
      url: `/cas/getTicket?timer=${new Date().getTime()}`
    }).then(res => {
      return Promise.resolve(res.ticket)
    })
  }
  async logoutBySsoToken() {
    return this.post({
      url: "/cas/logoutBySsoToken"
    }).then(res => {
      return Promise.resolve(res.ticket)
    })
  }
  async ssoLogin(params) {
    return this.post({
      url: "/cas/ssoLogin",
      data: params
    }).then(res => {
      return Promise.resolve(res)
    })
  }
}
